export default "__VITE_ASSET__B8ORVEoB__"